<template>
  <div>
      <table class="table table-hover" v-bind:id="id">
        <thead>
          <tr>
            <th>Tramite</th>
            <th>Tipo</th>
            <th>Tipo Operación</th>
            <th>Cuota Minimo</th>
            <th>Cuota Maximo</th>
            <th>Costo Operación</th>
            <th>Costo Fijo</th>
            <th>Porcentaje</th>
            <th>&nbsp;</th>
          </tr> 
        </thead>
        <tbody> </tbody>
      </table>
    </div>
</template>
<script>
import { parseJSON } from 'jquery';

  export default {
    name:"TableSampleCostos",
    props: {id:'',data_:[],lengthMenu:[]},
    mounted () {
      this.createdTable();
      window.tableCostos= this;
    },

    methods:{
      createdTable(){
          $('#'+this.id).DataTable( {
            "data": this.data_,
            "columns": [
              {"data": "tramite","title":"Tramite"},
              {"data": "tipo","title":"Tipo", "render":this.tipo},
              {"data": "ticosto","title":"Tipo Operación", "render":this.tipoCosto},
              {"data":"minimo","title":"Cuota Minimo","render":this.detalleCampos},
              {"data": "maximo","title":"Cuota Maximo","render":this.detalleCampos},              
              {"data":"valor","title":"Costo Operación","render":this.detalleCampos},
              {"data":"costo_fijo","title":"Costo Fijo","render":this.detalleCampos},
              {"data":"porcentaje","title":"Porcentaje","render":this.detalleCampos},
              {"render": this.btnDetalle ,"width":'15%'},          
            ]
          });
      },
      accionEditar(dato){
        this.$emit('accionEditar', dato);
      },
      accionEliminar(id,tramite,tipo){
        this.$emit('accionEliminar', id,tramite,tipo);
      },
      accionSubsidio(data){
        this.$emit('accionSubsidio', data);
      },
      accionPorcentaje(id,porcentaje){
        this.$emit('accionPorcentaje', id,porcentaje);
      },
      btnDetalle(data, type, row, meta){
        let btn= "<td class='text-center' width='20%'>"+
        "<a class='btn btn-icon-only btn-circle blue' href='#portlet-config' data-toggle='modal' data-original-title='' title='Editar' onclick='"+"accionEditar("+JSON.stringify(row)+")'><i class='fa fa-pencil'></i></a>"+
        "<a class='btn btn-icon-only btn-circle red' data-toggle='modal' href='#portlet-deleted' title='Eliminar' onclick='accionEliminar("+row.id+",\""+row.tramite+"\",\""+row.tipo+"\")'><i class='fa fa-minus'></i></a>"+
        "<a class='btn btn-icon-only btn-circle green' data-toggle='modal' href='#portlet-subsidio' title='Subsidio' onclick='accionSubsidio("+JSON.stringify(row)+")'><i class='fa fa-usd'></i></a>"+
        "<a class='btn btn-icon-only btn-circle blue' data-toggle='modal'data-original-title='' title='Porcentaje' href='#portlet-porcentaje' onclick='accionPorcentaje("+row.id+",\""+row.porcentaje+"\")'><i class='fa fa-percentage'><strong>%</strong></i></a>"+
        "</td>";
        return btn;
      },
      tipoCosto(data, type, row, meta){
        switch(row.costo){
          case 'H':
            return "Hoja";
          case 'M':
            return "Millar";
          case 'N':
            return "No Aplica";
          case 'C':
            return "Campo";
          case 'L':
            return "Lote";
          default:
            return "N/A";
        }
      },
       tipo(data, type, row, meta){
        let tipo="";
        if(row.tipo=='F'){tipo="Fijo";}else if(row.tipo=='I'){tipo="Impuesto";}else{tipo="Variable";}
        return tipo;
      },
      detalleCampos(data,type, row, meta){
        let valor= "";
        if(data==null || data==undefined || data==""){
          valor="N/A";
        }else{
          valor=data;
        }
        return valor;
      }
    }        
  }
</script>
